module.exports = __webpack_public_path__ + "static/media/npi-education.776ad021.jpeg";